export default [
  /**
   * 投诉建议
   */
  {
    path: "/feedback/submit",
    component: () => import("../page/feedback/index")
  },
  /**
   * 我的反馈
   */
  {
    path: '/feedback/list',
    component: () => import('../page/feedback/list')
  },
  /**
   * 我的反馈详情
   * @query.index 常用就诊人索引
   */
  {
    path: '/feedback/detail',
    component: () => import('../page/feedback/detail')
  }
]



// WEBPACK FOOTER //
// ./src/router/feedback.js